export default "__VITE_ASSET__C8ygqeg9__"